import { performRequest } from "../performRequest"



export const getRolesApi = (params) => {
    return performRequest("get", "/api/ess/roles/",params)
}


export const getPermissionsApi = (params) => {
    return performRequest("get", "/api/ess/permission-list/",params)
}


export const updatePermissionsApi = (id, params) => {
    return performRequest("patch", `/api/ess/roles/${id}/`,params)
}



